import React, { useCallback, useEffect, useRef, useState } from "react";
import { SITE } from "../data/nav";

// Weighted trigger pool: jiggle common, spin occasional, wink rare.
const WEIGHTED_ANIMS = ["jiggle", "jiggle", "jiggle", "jiggle", "jiggle", "jiggle", "spin", "spin", "spin", "wink"];
const NUDGE_MS = 22000;

// The GDPRLocal pin as a friendly copilot mascot. Eyes blink ambiently. On each
// trigger (hover, or the copilot starting to talk) it plays exactly one random
// animation (jiggle mostly, spin sometimes, wink rarely). It waves hello when
// findings first load, and waves again if the visitor sits idle for a while.
export const CopilotAvatar = ({ className = "", talking = false, blink = true, greet = false, idleNudge = false }) => {
  const [anim, setAnim] = useState(null);
  const prevTalking = useRef(talking);
  const lastActivity = useRef(Date.now());

  const play = useCallback((kind) => {
    lastActivity.current = Date.now();
    setAnim((cur) => {
      if (cur) return cur; // one animation per trigger
      return kind || WEIGHTED_ANIMS[Math.floor(Math.random() * WEIGHTED_ANIMS.length)];
    });
  }, []);

  useEffect(() => {
    if (greet) { setAnim("wave"); lastActivity.current = Date.now(); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (talking && !prevTalking.current) play();
    prevTalking.current = talking;
  }, [talking, play]);

  useEffect(() => {
    if (!idleNudge) return;
    const id = setInterval(() => {
      if (Date.now() - lastActivity.current >= NUDGE_MS) play("wave");
    }, 4000);
    return () => clearInterval(id);
  }, [idleNudge, play]);

  const eyeWink = anim === "wink";

  return (
    <div className={`relative ${className}`} data-testid="copilot-avatar">
      <div
        className={`copilot-face ${anim ? `anim-${anim}` : ""}`}
        onMouseEnter={() => play()}
        onAnimationEnd={(e) => { if (e.target === e.currentTarget) setAnim(null); }}
      >
        <img
          src={SITE.icon}
          alt="GDPRLocal compliance copilot"
          className="w-full h-full object-contain select-none"
          draggable="false"
        />
        <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
          <span className={`avatar-eye ${blink ? "is-blinking" : ""}`} style={{ left: "36.5%", top: "20%" }} />
          <span className={`avatar-eye avatar-eye--r ${eyeWink ? "is-winking" : blink ? "is-blinking" : ""}`} style={{ left: "54.5%", top: "20%" }} />
        </div>
      </div>
    </div>
  );
};
